<template>
  <el-dialog
    :visible.sync="visible"
    width="400px"
    title="子账号划拨"
    class="allocate"
  >
    <div class="content">
       <el-row>
        <el-col :span="5">父级回收：</el-col>
        <el-col :span="19">
          <el-radio-group v-model="recycle">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row v-if="!recycle">
        <el-col :span="5">目标账号：</el-col>
        <el-col :span="19">
          <select-tree
            class="select_input"
            size="medium"
            :defaultProps="defaultProps"
            ref="selectTree"
            :type="transferSimType"
            @node-dblclick="(node) => (activeNode = node)"
            :treeData="grounpsTree"
          />
        </el-col>
      </el-row>
      <div class="footer">
        <el-button size="small" @click="visible = false">取消</el-button>
        <el-button size="small" type="primary" @click="onConfirm">确认划拨</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import selectTree from "@/components/selectTree/";
export default {
  name:"childrenAllocate",
  props:{
    simCards:{
      type:Array,
      default:()=>[]
    },
    grounpsTree:{
      type:Array,
      default:()=>[]
    },
    sourceUserId:{
      type:Number,
      default:0
    }
  },
  components:{
    selectTree
  },
  data(){
    return {
      recycle:0,
      visible:false,
      defaultProps: {
        children: "children",
        label: "name",
      },
      transferSimType: 1,
      activeNode: null,
    }
  },
  methods:{
    //确认划拨按钮
    async onConfirm(){
      try{
        if(this.activeNode && !this.activeNode.userId) throw "请选择目标账号";
        const { data } = await this.$API.transferSimCard({
          sourceUserId:this.sourceUserId,
          targetUserId:this.recycle ? this.$store.state.LOGINUSER.id : this.activeNode.userId,
          simCards:this.simCards.map(item=>item.simCard).join(','),
        });
        if(data.code !== 0) throw data.msg;
        if(data.code === 0){
          this.$message({
            type:"success",
            message:'划拨成功'
          });
          this.visible = false;
          this.activeNode = null;
          this.$emit("handleSuccess");
        }
      }catch(msg){
        this.$message({
          type:"warning",
          message:msg
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.allocate {
  ::v-deep .el-dialog__body{
    padding: 20px;
  }
  ::v-deep .el-row{
    line-height: 36px;
  }
  .footer{
    margin-top: 20px;
    text-align: right;
  }
}
</style>